var React = require('react');

function MudraDhyana (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M24.5,26.646c2-0.287,2.5,0.895,2.5,1.729\n\tc0,0.786-0.536,1.555-1.359,1.829C23.598,30.885,20.782,31,19,31c-2.969,0-7.792-1.083-11.375-4.666c-4-4-5.48-6.916-6.625-7.334v-6\n\tc0,0,2,0,5,0s6,2,6,2s3.896,0,5,0s2,0.896,2,2s-0.896,2-2,2s-2.583,0-4,0s-2,0.75-2,2c0,3.875,4.167,6,9,6c2.5,0,6.781-0.125,11-3\n\tc4.675-3.186,5.031-4.648,6-5v-6c0,0-2,0-5,0s-6,2-6,2s-3.896,0-5,0s-2,0.896-2,2s0.896,2,2,2s2.584,0,4,0c0.875,0,2,0.084,2,1.334\n\tC27,22.042,23.958,23,20,23c-2.554,0-4.672-0.948-6.134-1.877c-1.401-0.889-2.849,0.284-2.849,0.284"}));
}

MudraDhyana.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = MudraDhyana;

MudraDhyana.default = MudraDhyana;
